import { formatDate } from "@/utils/dateHelpers";
import { Card, CardContent, Box, Typography, Chip, Switch } from "@mui/material";
import { ToolView } from "@my-helpers/common";
import { ElementType } from "react";
import { useNavigate } from "react-router-dom";


interface ToolSummaryProps {
    tool: ToolView;
    toggleUserToolStatus: (toolId: string, enabled: boolean) => void;
}

export const ToolSummaryCard: ElementType<ToolSummaryProps> = (
    { tool, toggleUserToolStatus }) => {
    const navigate = useNavigate();

    const getStatusColor = (enabled: boolean) => {
        return enabled ? 'success' : 'default';
    };

    const getCategoryColor = (category: string) => {
        const colors: Record<string, 'primary' | 'secondary' | 'info' | 'warning'> = {
            document: 'primary',
            web: 'info',
            ai: 'secondary',
            database: 'warning'
        };
        return colors[category] || 'primary';
    };

    return (
        <Card
            onClick={() => navigate(`/tools/${tool.id}`)}
            sx={{
                height: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 4
                }
            }}
        >
            <CardContent sx={{ padding: "16px !important" }}>
                <Typography variant="h6" component="h2" noWrap>
                    {tool.provider}
                </Typography>
               
                <Typography variant="body2" color="text.secondary" mb={2}>
                    {tool.description}
                </Typography>

                <Box display="flex" flexWrap="wrap" mb={2} gap={1}>
                    <Chip
                        label={tool.user_enabled ? 'Enabled' : 'Disabled'}
                        color={getStatusColor(tool.user_enabled)}
                        size="small"
                    />
                    {
                        tool.tagged_by && tool.tagged_by.map((tag: string) => (
                            <Chip
                                label={tag}
                                color="default"
                                size="small"
                                variant="outlined"
                            />
                        ))
                    }
                    <Chip
                        label={tool.provider}
                        color={getCategoryColor(tool.provider)}
                        size="small"
                        variant="outlined"
                    />
                </Box>
                <Box 
                    display="flex" 
                    flexDirection="row" 
                    flexWrap="wrap"
                    alignItems="center"
                >
                    <Typography flex={1} variant="caption" color="text.secondary">
                        Last updated: {formatDate(tool.updated_at)}
                    </Typography>
                    <Switch
                        checked={tool.user_enabled}
                        size="small"
                        onChange={(_, checked) => toggleUserToolStatus(tool.id, checked)}
                        onClick={(e) => e.stopPropagation()}
                        color="primary"
                    />
                </Box>

            </CardContent>
        </Card>
    );
}